import gsap from 'gsap'

export const initLoader = () => {

	const header = document.querySelector('.header')
	const loader = document.querySelector('.loader')
	const logo = document.querySelector('.loader__logo')
	const fill = document.querySelector('.loader__fill')
	const bannerLogo = document.querySelectorAll('.banner__logo path')
	const bannerTagline = document.querySelectorAll('.banner__tagline')
	const bannerTagline2 = document.querySelectorAll('.banner__tagline--2')

	if (!logo || !fill || !window.initialLoad) return

	const tl = gsap.timeline()

	tl.fromTo(fill, {
		yPercent: 100
	}, {
		yPercent: 0,
		duration: 2.8,
		ease: 'power2.out',
		overwrite: true
	})

	tl.fromTo(loader, {
		clipPath: 'inset(0 0 0 0)'
	}, {
		clipPath: 'inset(0 0 100% 0)',
		duration: 1.6,
		ease: 'expo.inOut',
	}, '-=1.2')

	tl.fromTo(logo, {
		scale: 1
	}, {
		scale: 0.5,
		duration: 1.8,
		ease: 'expo.inOut',
	}, '<')

	tl.fromTo(bannerLogo, {
		y: 200,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 2,
		stagger: 0.05,
		ease: 'expo.out',
	}, '-=1')

	tl.fromTo(header, {
		yPercent: -400
	}, {
		yPercent: 0,
		duration: 1.8,
		ease: 'expo.inOut',
		clearProps: 'all'
	}, '-=2.6')
	
	tl.add(() => {
		loader.remove()
	})

	bannerTagline.forEach((el, index) => {
		const char = el.querySelectorAll('.char')
		const overlap = index === 0 ? '-=1.2' : '-=0.6'

		tl.fromTo(char, {
			opacity: 0
		}, {
			opacity: 1,
			stagger: 0.06,
			duration: 1.2
		}, overlap)
	})
}

export default () => {}